// extracted by mini-css-extract-plugin
module.exports = {"root":"ITR5M9B_","title":"lTptlLQa"};